import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'female-korean-glow-diet',
	landing: {
		ids: ['loader-f-korean-glow-diet'],
		route: {
			path: '/korean-glow-diet-f',
			name: 'female-korean-glow-diet-funnel',
		},
	},
	funnel: {
		id: 'ob-female-korean-glow-diet',
		route: {
			path: '/korean-glow-diet-f/ob/:page(.*)?',
			name: 'female-korean-glow-diet',
		},
		slug: 'female-korean-glow-diet',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-korean-glow-diet-f',
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-f'],
	},
}

export default appAreaConfig
